module.exports = __webpack_public_path__ + "static/media/waiter-success-animation.6b32f34f.svg";